import { Provider } from '@angular/core';
import { AUDIT_MODULE_CONFIG, AuditModuleConfig } from './core/audit.config';

/**
 * Supplies the audit module's API endpoints.
 *
 * Either on the lazy route (preferred — keeps the config with the feature):
 *
 *   {
 *     path: 'audit',
 *     loadChildren: () => import('./audit-module/audit.module').then(m => m.AuditModule),
 *     providers: provideAuditModule({
 *       identityApiUrl:  environment.apiConfig.IdentityAPI.endpoint,
 *       corporateApiUrl: environment.apiConfig.corporateAPI.endpoint,
 *       invoicingApiUrl: environment.apiConfig.legacyInvoicingApi.endpoint,
 *     }),
 *   }
 *
 * ...or in the root `providers` array of AppModule, spread with `...`.
 */
export function provideAuditModule(config: AuditModuleConfig): Provider[] {
  return [{ provide: AUDIT_MODULE_CONFIG, useValue: config }];
}
